import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export interface EstadoVacioProps {
  icono?: LucideIcon;
  titulo: string;
  detalle?: string;
  /** "Limpiar filtros", "Recibir el primer equipo". */
  accion?: ReactNode;
  /** `sm`: dentro de una tabla o lista mobile. `md`: pantalla o seccion vacia. */
  tamano?: "sm" | "md";
  className?: string;
}

/**
 * Nunca una pantalla en blanco: siempre se dice que falta y que va a haber ahi.
 *
 * NO es el estado de carga: "Buscando..." como mensaje vacio va a `Cargando`.
 * Un solo padding grande (`p-8`): 32px es lo justo para que el tile de 48
 * respire sin que parezca una landing.
 */
export function EstadoVacio({
  icono: Icono,
  titulo,
  detalle,
  accion,
  tamano = "md",
  className,
}: EstadoVacioProps): JSX.Element {
  if (tamano === "sm") {
    // Sin Card: lo envuelve el td o la tarjeta de la lista.
    return (
      <div
        className={cn(
          "flex flex-col items-start gap-2 p-4 text-sm text-muted-foreground",
          className,
        )}
      >
        <p>{titulo}</p>
        {detalle ? <p className="text-xs">{detalle}</p> : null}
        {accion}
      </div>
    );
  }

  return (
    <Card
      variant="dashed"
      padding="none"
      className={cn("flex flex-col items-center gap-3 p-8 text-center", className)}
    >
      {Icono ? (
        <div className="flex size-12 items-center justify-center rounded-lg bg-accent text-accent-foreground [&_svg]:size-6">
          <Icono aria-hidden="true" />
        </div>
      ) : null}
      <div className="space-y-1">
        <p className="text-sm font-medium">{titulo}</p>
        {detalle ? (
          <p className="mx-auto max-w-md text-sm text-muted-foreground">{detalle}</p>
        ) : null}
      </div>
      {accion ? <div className="mt-1">{accion}</div> : null}
    </Card>
  );
}
